import AdvantageSection from "@app/components/acquisitions-sections/advantage-section";
import CompanyOutlookSection from "@app/components/acquisitions-sections/company-outlook-section";
import ConnectSection from "@app/components/connect-section";
import EmployeesSection from "@app/components/acquisitions-sections/employees-section";

const AcquisitionsPage = () => <div>
    <AdvantageSection />
    <EmployeesSection />
    <CompanyOutlookSection />
    <ConnectSection />
</div>

export default AcquisitionsPage;
